import classNames from "classnames";
import { useAppSelector } from "hooks/useAppSelector";
import { useChatLocation } from "hooks/useChatLocation";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useHistory } from "react-router-dom";

const Pills = ({ className }: { className?: string }) => {
  const { chatBasePath, section } = useChatLocation();
  const count = useAppSelector((state) => state.chat.unrepliedChannelCount);
  const history = useHistory();

  const pill = (active: boolean) =>
    classNames(
      "all:unset t-flex t-items-center t-gap-1 t-rounded-full t-px-3 t-py-1 t-text-body-sm t-whitespace-nowrap t-cursor-pointer",
      {
        "t-bg-purple t-text-white": active,
        "t-text-text-30 t-border t-border-solid t-border-neutral-10": !active,
      }
    );

  return (
    <div className={classNames("t-flex t-items-center t-gap-2", className)}>
      <button
        className={pill(section === null)}
        onClick={() => history.push(chatBasePath)}
      >
        All chats
      </button>
      <button
        className={pill(section === "unreplied")}
        onClick={() => history.push(`${chatBasePath}/unreplied`)}
      >
        Unreplied
        {count > 0 && (
          <span
            className={classNames("t-rounded-full t-px-1.5 t-text-caption", {
              "t-bg-white/20 t-text-white": section === "unreplied",
              "t-bg-neutral-10 t-text-text-30": section !== "unreplied",
            })}
          >
            {count > 99 ? "99+" : count}
          </span>
        )}
      </button>
    </div>
  );
};

// Compact All chats / Unreplied switch for CPAs, stands in for the chat page
// tabs on breakpoints where those are hidden.
export const ChatFilterPills = ({ className }: { className?: string }) => {
  const { isInChat } = useChatLocation();
  const { isCpa } = useRoleBasedView();
  const { showAIChannels } = useAppSelector((state) => state.chatSearch);

  // Outside the chat routes there is no section to switch between
  if (!isCpa || !isInChat || showAIChannels) return null;

  return <Pills className={className} />;
};
